export const userGroupIdShouldBeNumber = "User group ID should be a number";
export const userGroupAlreadyExists = "User group already exists";
export const addGroupIdValidation = "Please provide user group ID";
export const noAvailableUserGroups = "There are no available user groups";
